import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import HotSwapOptionCard from './components/hot-swap-option-card'
import { withRouter } from 'react-router-dom'
import { HOTSWAP_TYPES } from './constants/constants'
import HotSwapUsFlow from './hot-swap-us-flow'
import HotSwapSbuFlow from './hot-swap-sbu-flow'
import { HOTSWAP_PERMISSIONS } from '../root/constants'

const useStyles = makeStyles(() => ({
    wrapper: {
        display: 'flex',
        alignItems: 'stretch',
        justifyContent: 'center',
        gap: '98px',
        marginTop: '6rem'
    }
}))

const { allowed_hotswap_request, allowed_update_service } = HOTSWAP_PERMISSIONS

function HotSwapStart() {
    const classes = useStyles()
    const history = useHistory()

    const { selectedHotSwapLocations } = useSelector(state => state.hotswap)

    const [selectedSwapOption, setSelectedSwapOption] = useState(null)

    useEffect(() => {
        if (
            !selectedHotSwapLocations ||
            selectedHotSwapLocations.length === 0
        ) {
            history.push(`/hot-swap`)
        }
    }, [selectedHotSwapLocations, history])

    return (
        <>
            {!selectedSwapOption && (
                <div className={classes.wrapper}>
                    {localStorage.getItem(allowed_hotswap_request) && (
                        <HotSwapOptionCard
                            swapType={HOTSWAP_TYPES.SBU}
                            handleBtnClick={() =>
                                setSelectedSwapOption(HOTSWAP_TYPES.SBU)
                            }
                        />
                    )}
                    {localStorage.getItem(allowed_update_service) && (
                        <HotSwapOptionCard
                            swapType={HOTSWAP_TYPES.US}
                            handleBtnClick={() =>
                                setSelectedSwapOption(HOTSWAP_TYPES.US)
                            }
                        />
                    )}
                </div>
            )}
            {selectedSwapOption === HOTSWAP_TYPES.SBU && (
                <HotSwapSbuFlow
                    selectedHotSwapLocations={selectedHotSwapLocations}
                    setSelectedSwapOption={setSelectedSwapOption}
                />
            )}
            {selectedSwapOption === HOTSWAP_TYPES.US && (
                <HotSwapUsFlow
                    selectedHotSwapLocations={selectedHotSwapLocations}
                    setSelectedSwapOption={setSelectedSwapOption}
                />
            )}
        </>
    )
}

export default withRouter(HotSwapStart)
